export const main: angular.IComponentOptions = {
  template: require('./main.html')
};




// WEBPACK FOOTER //
// ./src/app/main.ts